import React, { useEffect } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const EASE = [0.23, 1, 0.32, 1] as const;
const words = ['Do', 'it,', "Don't", 'poo', 'it!'];

/** Kratek uvodni zaslon ob zagonu. Tap ali tipka ga preskoči. */
export function Splash({
  onDone
}: {
  onDone: () => void;
}) {
  const reduce = useReducedMotion();
  useEffect(() => {
    const t = window.setTimeout(onDone, reduce ? 600 : 1900);
    const onKey = () => onDone();
    window.addEventListener('keydown', onKey);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener('keydown', onKey);
    };
  }, [onDone, reduce]);
  return <motion.div role="button" tabIndex={0} aria-label="Do it, Don't poo it! Tapni za nadaljevanje." onClick={onDone} initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.25,
    ease: EASE
  }} className="fixed inset-0 z-[100] flex cursor-pointer flex-col items-center justify-center bg-canvas px-6 font-sans text-ink" data-id="element-922" data-mp="xh38j6bw7d8p">
      <motion.span initial={reduce ? false : {
      opacity: 0,
      scale: 0.6,
      rotate: -40
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: -6
    }} transition={reduce ? {
      duration: 0
    } : {
      type: 'spring',
      stiffness: 380,
      damping: 16
    }} className="grid h-20 w-20 place-items-center rounded-3xl bg-sun shadow-press md:h-24 md:w-24" aria-hidden="true" data-id="element-923" data-mp="d4xt9ky51tac">
        <motion.span initial={reduce ? false : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.25,
        duration: 0.2,
        ease: EASE
      }} data-id="element-924" data-mp="3lmu06kxjazwn">
          <CheckIcon className="h-11 w-11 md:h-14 md:w-14" strokeWidth={3.5} data-id="element-925" data-mp="3boxqlxk8wd0n" />
        </motion.span>
      </motion.span>

      <h1 className="mt-8 flex flex-wrap justify-center gap-x-3 text-center font-display text-5xl leading-tight text-accent-ink md:text-7xl" data-id="element-926" data-mp="19vgae5i1u3ua">
        {words.map((w, i) => <motion.span key={w + i} initial={reduce ? false : {
        opacity: 0,
        y: 24,
        rotate: i % 2 ? 4 : -4
      }} animate={{
        opacity: 1,
        y: 0,
        rotate: 0
      }} transition={{
        delay: 0.3 + i * 0.08,
        type: 'spring',
        stiffness: 420,
        damping: 18
      }} className={w === 'poo' ? 'text-ink' : undefined} data-id="element-927" data-mp="1erx6pmzejoig" data-mpi={i}>
            {w}
          </motion.span>)}
      </h1>

      <motion.p initial={reduce ? false : {
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.85,
      duration: 0.25,
      ease: EASE
    }} className="mt-4 text-sm font-bold text-muted" data-id="element-928" data-mp="1w3c8us5zi8nr">
        Kljukice namesto izgovorov.
      </motion.p>
    </motion.div>;
}